<template>
  <header class="position-sticky">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-3 col-lg-3">
          <div class="logo-container d-none d-md-inline-block">
            <a href="/"><img src="../assets/images/logo.svg" class="d-block" alt="" style="margin: 40px 0 10px 0;"></a>
          </div>

          <a href="/" class="d-inline-block d-md-none" style="margin: 15px 0 0 15px;"><img src="../assets/images/logo.svg" class="d-block" alt="" style="width: auto; height: 50px;"></a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  export default {
    name: "site-header",
    data() {
      return {
        events: []
      }
    },
    async mounted() {
    }
  }
</script>

<style lang="scss" scoped>
  // header { height: 61px; }
  header { min-height: 80px; top: 0; z-index: 1; background-color: #FFF; }

  .logo-container {
    img {
      width: 181px;
      height: 74px;
    }
  }

  .header-border {
    height: 58px;
  }

  .header-link {
    color: #FFF;

    &:hover {
      text-decoration: underline;
    }
  }
</style>